const config = require("../configs/config.json");

const stripeKey = config["STRIPE_API_KEY"];
if (!stripeKey) {
  console.error("Stripe API key not properly configured");
}

const apiUrl = config["API_URL"];
if (!apiUrl) {
  console.error("API URL not properly configured");
}

const beamerCode = config["BEAMER_PRODUCT_CODE"];
if (!beamerCode) {
  console.error("Beamer CODE key not properly configured");
}

const plaidKey = config["PLAID_PUBLIC_KEY"];
if (!plaidKey) {
  console.error("Plaid CODE key not properly configured");
}

const flatFileKey = config["FLATFILE_LICENCE_KEY"];
if (!flatFileKey) {
  console.error("Flatfile key not properly configured");
}

const hubspotAppId = config["HUBSPOT_APP_ID"];
if (!hubspotAppId) {
  console.error("Hubspot ID not properly configured");
}

const plaidMode = config["PLAID_MODE"];
if (!plaidMode) {
  console.error("Plaid mode not properly configured");
}

const integrationsMode = config["INTEGRATIONS_MODE"];
if (!integrationsMode) {
  console.error("Integrations mode not properly configured");
}

// Zendesk
const zendeskApiKey = config["ZENDESK_API_KEY"];
if (!zendeskApiKey) {
  console.error("Zendesk api key not properly configured");
}

const zendeskSupportKey = config["ZENDESK_SUPPORT_KEY"];
if (!zendeskSupportKey) {
  console.error("Zendesk support api key not properly configured");
}

const zendeskQuestionResponsibleAgentId =
  config["ZENDESK_QUESTION_RESPONSIBLE_AGENT_ID"];
if (!zendeskQuestionResponsibleAgentId) {
  console.error(
    "Zendesk question responsible agent id zendesk id not properly configured"
  );
}

const zendeskIssueResponsibleAgentId =
  config["ZENDESK_ISSUE_RESPONSIBLE_AGENT_ID"];
if (!zendeskIssueResponsibleAgentId) {
  console.error("Zendesk issue responsible agent id not properly configured");
}

const zendeskQuestionCcEmails = config["ZENDESK_QUESTION_CC_EMAILS"];
if (!zendeskQuestionCcEmails) {
  console.error("Zendesk question CC emails not properly configured");
}

const zendeskIssueCcEmails = config["ZENDESK_ISSUE_CC_EMAILS"];
if (!zendeskIssueCcEmails) {
  console.error("Zendesk issue CC emails not properly configured");
}

const testPreviewContactId = config["TEST_PREVIEW_CONTACT_ID"];
if (!testPreviewContactId) {
  console.error(
    "Contact ID for templates preview feature not found. This feature is disabled."
  );
}

export {
  stripeKey,
  apiUrl,
  beamerCode,
  flatFileKey,
  hubspotAppId,
  plaidKey,
  plaidMode,
  integrationsMode,
  zendeskApiKey,
  zendeskQuestionResponsibleAgentId,
  zendeskIssueResponsibleAgentId,
  zendeskQuestionCcEmails,
  zendeskIssueCcEmails,
  testPreviewContactId
};
